/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Picker_PromptInputs */

const en_picker_prompt = /** @type {(inputs: Picker_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select your check-in and check-out dates`)
};

/**
* | output |
* | --- |
* | "Select your check-in and check-out dates" |
*
* @param {Picker_PromptInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const picker_prompt = /** @type {((inputs?: Picker_PromptInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Picker_PromptInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_picker_prompt(inputs)
});